import React, { useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ExpandMore from '@material-ui/icons/ExpandMore'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Collapse from '@material-ui/core/Collapse';
import ReactTooltip from 'react-tooltip';
import IconCarolus from '../assets/ic_carolus.png'
import HomeRoutes from '../router/homeRoutes'
import dashboard from '../assets/ic_web_dashboard.png';
import masterData from '../assets/ic_web_mstdata.png';
import transaksi from '../assets/ic_web_transaction.png';
import dokter from '../assets/ic_web_doctor.png';
import telemedicine from '../assets/ic_telemedicineWeb.png';
import lab from '../assets/ic_web_lab.png';
import nurseStation from '../assets/ic_web_nursestation.png';
import CloseImage from '../assets/ic_close.png';
import farmasi from '../assets/ic_web_pharmacy.png';
import radiologi from '../assets/ic_web_radiology.png';
import regisbpjs from '../assets/ic_web_regisbpjs.png';
import regisgeneral from '../assets/ic_web_regisgeneral.png';
import regisasuransi from '../assets/ic_web_regisinsurance.png';
import berkasbpjs from '../assets/ic_web_submitFileBPJS.png';
import report from '../assets/ic_web_report.png';
import emergency from '../assets/ic_emergency.png';
import schedule from '../assets/ic_web_schedule.png';
import screening from '../assets/ic_web_screening.png';
import setting from '../assets/ic_web_setting.png';
import registration from '../assets/ic_web_registration.png';
import back from '../assets/ic_back.png';
import circle from '../assets/ic_circle.png';
import icClose from '../assets/ic_close3.png';
import icProses from '../assets/ic_process.png';
import icUpload from '../assets/ic_uploadFile.png'
import icOtherMenu from '../assets/ic_otherMenu.png'
import Pusher from 'pusher-js';
import { titleCase } from '../library/Util'

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useParams,
    useRouteMatch, useLocation, useHistory
} from "react-router-dom";
import { Avatar, ListItemText, Menu, MenuItem, TextField, Snackbar } from '@material-ui/core';
import { usePrevious, UseWindowDimensions } from '../library/Util';
import Images from '../assets/Images';
import Constant from '../library/Constant';
import api from './api';
import MuiAlert from '@material-ui/lab/Alert';
import { green } from '@material-ui/core/colors';
import { withStyles, Radio } from '@material-ui/core';
import { titleText } from '../library/titleText';

const GreenRadio = withStyles({
    root: {
        color: green[400],
        '&$checked': {
            color: green[600],
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const drawerWidth = 325;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        minWidth: 60,
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    topleftOpen: {
        width: drawerWidth,
        borderRight: 0,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        backgroundColor: '#273b80'
    },
    topleftClose: {
        borderRight: 0,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(3) + 2,
        height: '78px',
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(7) + 1,
        },
        padding: 20,
        display: 'flex',
        backgroundColor: '#273b80'
    },
    drawerOpen: {
        width: drawerWidth,
        borderRight: 0,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        backgroundColor: '#2a9c6c',
    },
    drawerClose: {
        borderRight: 0,
        minWidth: 60,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(3) + 2,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(7) + 7,
        },
        backgroundColor: '#2a9c6c',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        // justifyContent: 'flex-end',
        padding: theme.spacing(0, 1.5),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    toolbarDrawer: {
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        // ...theme.mixins.toolbar
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    orangeAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: 'black',
    },
    underline: {
        "&&&:before": {
            borderBottom: "none"
        },
        "&&:after": {
            borderBottom: "none"
        }
    }
}));

export default function MiniDrawer() {
    const history = useHistory();
    let location = useLocation();
    // console.log(location);
    const classes = useStyles();
    const theme = useTheme();
    const [arrayEmergency, setArrayEmergency] = React.useState([]);
    const [selectedSubIndex, setSelectSub] = React.useState([]);
    const [selectedSubPath, setSelectSubPath] = React.useState("");
    const [referral, setReferral] = React.useState("");
    const [selectedIndex, setSelectedIndex] = React.useState("Dashboard");
    const [selectedPath, setSelectedPath] = React.useState("dashboard");
    const [open, setOpen] = React.useState(false);
    const [nama, setNama] = React.useState("");
    const [role, setRole] = React.useState("");
    const [reservasi, setDataReservasi] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [menuid, setMenuid] = React.useState("");
    const [visibleFloat, setVisibleFloat] = React.useState(false);
    const [visibleNotif, setVisibleNotif] = React.useState(false);
    const [newNotes, setNewNotes] = React.useState("");
    const [visibleStopFacility, setVisibleStopFacility] = React.useState(false);
    const [visibleStopDoctor, setVisibleStopDoctor] = React.useState(false);
    const [showNotif, setShowNotif] = React.useState(true);
    const [detailNotif, setDetailNotif] = React.useState(null);
    const [selectNotification, setSelectNotification] = React.useState(null);
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const [notificationType, setNotificationType] = React.useState(false);
    const [data, setData] = React.useState([])
    const [dataNotication, setDataNotification] = React.useState([])
    const [pickDataNotification, setPickDataNotification] = React.useState(null)
    const options = [
        'Profile',
        'Logout',
    ];

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [visiblePopup, setVisiblePopup] = React.useState(false);
    const openMenu = Boolean(anchorEl);
    const [pathname, setPathname] = React.useState("")
    const [menu, setMenu] = React.useState("")
    const [notifHTML, setNotifHTML] = React.useState(false)
    const [paramStop, setParamStop] = React.useState(0)
    const [title, setTitle] = React.useState("")

    const handleClickMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const ITEM_HEIGHT = 48;

    const { height, width } = UseWindowDimensions();

    const logout = () => {
        localStorage.removeItem(Constant.token)
        localStorage.removeItem(Constant.ACCESS_TOKEN)
        localStorage.removeItem(Constant.REFRESH_TOKEN)
        localStorage.removeItem(Constant.CURRENT_COUNTER)
        localStorage.removeItem(Constant.SUB_FACILITY)
        window.location.reload();
    }

    const dataReservasi = (val) => {
        console.log(val);
        setDataReservasi(val)
    }

    const handleOption = (val) => {
        if (val === "Logout") {
            handleCloseMenu()
            logout()
        }
        console.log(val);
    }

    const handleOptionDropdown = (val) => {
        console.log(val);
    }

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
        let arr = data.array
        console.log(arr);
        if (arr !== undefined) {
            arr.map((item, index) => {
                if (item.collapse === true) {
                    arr[index].collapse = false
                }
            })
            setData({ ...data, data: arr })
        }
    };

    let { path, url } = useRouteMatch();
    const forceUpdate = React.useReducer(bool => !bool)[1];

    useEffect(() => {
        // console.log(localStorage.getItem(Constant.NAMA_RS), localStorage.getItem(Constant.LOGO_RS));
        let path = String(location.pathname).split('/')
        setPathname(path[1])
        if (menu === "") {
            // console.log('masuk');
            getMenu()
        }
        setLoading(true)
        getTitle()
    })

    useEffect(() => {
        const interval = setInterval(() => {
            // let path = String(location.pathname).split('/')
            // console.log(pathpath.length - 1);
            // getDataTable()
            getNotification()
            if (role === "IGD") {
                checkEmergency()
            }
        }, 2000);
        return () => clearInterval(interval);
    })

    const checkEmergency = () => {
        api.create().getListOrder().then(response => {
            if (response.data.data.length > 0) {
                let idx = response.data.data.filter(word => word.status === "Booking");
                if (idx.length > 0) {
                    let a = idx.filter(elm => !arrayEmergency.map(elm => JSON.stringify(elm)).includes(JSON.stringify(elm)));
                    if (a.length > 0) {
                        var options = {
                            body: `Ada ${idx.length} Booking`,
                            icon: "https://cms.daihatsu.co.id/uploads/tipsandtrick/ambulance-1610978500051.jpeg?    auto=compress&cs=tinysrgb&dpr=1&w=500",
                            dir: "ltr"
                        };
                        let notification = new Notification("Booking Baru", options);
                        notification.addEventListener("click", function (event) {
                            history.push({
                                pathname: '/emergency/active-order'
                            })
                            event.preventDefault();
                            console.log('Notification clicked.');
                        })
                        // notification.addEventListener("show", function (event) {

                        // })
                    }
                    setArrayEmergency(idx)
                    // if (visibleEmergency) {
                    // }
                } else {

                }
            }
        })
    }


    const getNotification = () => {
        api.create().notificationAntrian().then(response => {
            // console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data !== null) {
                        let data = response.data.data
                        if (Array.isArray(response.data.data)) {
                            if (data.length > 0) {
                                setDetailNotif(data[0])
                                setVisibleNotif(true)
                                setNotificationType("doctor")
                                setNotifHTML(true)
                            }
                            setDataNotification(data)
                        } else {
                            setNotificationType("fasilitas")
                            setDetailNotif(data)
                            setVisibleNotif(true)
                            setNotifHTML(true)
                        }
                    } else {
                        setSelectNotification(null)
                        setDetailNotif(null)
                        setVisibleNotif(false)
                    }
                } else {
                    // alert('Sesi token telah berakhir')
                    // localStorage.removeItem(Constant.ACCESS_TOKEN)
                    // localStorage.removeItem(Constant.REFRESH_TOKEN)
                    // localStorage.removeItem(Constant.CURRENT_COUNTER)
                    // localStorage.removeItem(Constant.SUB_FACILITY)
                    // window.location.reload();
                }
            }
        })
    }

    useEffect(() => {
        // let path = String(location.pathname).split('/')
        // let title = String(path[path.length - 1]).split("-").join(" ")
        // setTitle(titleText(titleCase(title)))
        getParameter()
        getNofitHTML()
    }, [notifHTML])

    const getTitle = () => {
        let path = String(location.pathname).split('/')
        let url = String(path[path.length - 2])
        let endpoint = String(path[path.length - 1])
        let title = url.concat("/", endpoint)
        setTitle(titleText(title))
    }

    const getParameter = () => {
        api.create().getParameter().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    response.data.data.map((item) => {
                        if (item.param_code === "STOP_CALL_QUEUE") {
                            var hms = item.param_value;   // your input string
                            var a = hms.split(':'); // split it at the colons
                            // minutes are worth 60 seconds. Hours are worth 60 minutes.
                            var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
                            var fix = seconds * 1000
                            setParamStop(fix)
                            // console.log(seconds);
                        }
                    })
                }
            }
        })
    }

    const getNofitHTML = () => {
        if (notifHTML === true) {
            setTimeout(() => {
                console.log(notifHTML);
                _showNotif()
            }, paramStop);
        }
    }

    const _showNotif = () => {
        if (notifHTML === true) {
            if (!("Notification" in window)) {
                alert("This browser does not support desktop notification");
            }
            // Let's check whether notification permissions have already been granted
            else if (Notification.permission === "granted") {
                // If it's okay let's create a notification
                var options = {
                    body: `Anda belum menyelesaikan antrian nomor ${selectNotification !== null ? selectNotification.queue_number : detailNotif.queue_number ? detailNotif.queue_number : '-'}. Klik disini untuk menampilkan layar MedApp`,
                    icon: "http://139.255.24.122:1180/medapp-public/assets/icon/IgMedIcon.png?    auto=compress&cs=tinysrgb&dpr=1&w=500",
                    dir: "ltr",
                    requireInteraction: true
                };
                let notification = new Notification("Perhatian!", options)
                notification.addEventListener("click", function (event) {
                    history.push({
                        pathname: '/dashboard'
                    })

                    window.focus();
                    event.preventDefault();
                    console.log('Notification clicked.');
                })
            }
            else if (Notification.permission !== "denied") {
                Notification.requestPermission().then(function (permission) {
                    // If the user accepts, let's create a notification
                    if (permission === "granted") {
                        var options = {
                            body: `Anda belum menyelesaikan antrian nomor ABCS123 dengan nama pasien Budiman Lalala. Klik disini untuk menampilkan layar MedApp`,
                            icon: "http://139.255.24.122:1180/medapp-public/assets/icon/IgMedIcon.png?    auto=compress&cs=tinysrgb&dpr=1&w=500",
                            dir: "ltr",
                            requireInteraction: true
                        };
                        let notification = new Notification("Perhatian!", options)
                        notification.addEventListener("click", function (event) {
                            history.push({
                                pathname: '/dashboard'
                            })

                            window.focus();
                            event.preventDefault();
                            console.log('Notification clicked.');
                        })
                    }
                });
            }
        }
    }

    const getMenu = () => {
        api.create().accessMenu().then(response => {
            // console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data.length > 0) {
                        setData({
                            array: response.data.data
                        })
                        setMenuid(response.data.data[0].id)
                        setMenu("Masuk")
                    } else {
                    }
                    // console.log(data);
                } else {
                    let payload = {
                        "refresh_token": localStorage.getItem(Constant.REFRESH_TOKEN)
                    }
                    api.create().refreshToken(payload).then(res => {
                        console.log(res);
                        if (res.data) {
                            if (res.data.status === true) {
                                localStorage.setItem(Constant.ACCESS_TOKEN, res.data.data.access_token)
                                localStorage.setItem(Constant.REFRESH_TOKEN, res.data.data.refresh_token)
                                window.location.reload();
                            } else {
                                localStorage.removeItem(Constant.ACCESS_TOKEN)
                                localStorage.removeItem(Constant.REFRESH_TOKEN)
                                localStorage.removeItem(Constant.CURRENT_COUNTER)
                                localStorage.removeItem(Constant.SUB_FACILITY)
                                window.location.reload();
                            }
                        }
                    })
                }
            } else {
                let payload = {
                    "refresh_token": localStorage.getItem(Constant.REFRESH_TOKEN)
                }
                api.create().refreshToken(payload).then(res => {
                    // console.log(res);
                    if (res.data) {
                        if (res.data.status === true) {
                            localStorage.setItem(Constant.ACCESS_TOKEN, res.data.data.access_token)
                            localStorage.setItem(Constant.REFRESH_TOKEN, res.data.data.refresh_token)
                            window.location.reload();
                        } else {
                            localStorage.removeItem(Constant.ACCESS_TOKEN)
                            localStorage.removeItem(Constant.REFRESH_TOKEN)
                            localStorage.removeItem(Constant.CURRENT_COUNTER)
                            localStorage.removeItem(Constant.SUB_FACILITY)
                            window.location.reload();
                        }
                    } else {
                        localStorage.removeItem(Constant.ACCESS_TOKEN)
                        localStorage.removeItem(Constant.REFRESH_TOKEN)
                        localStorage.removeItem(Constant.CURRENT_COUNTER)
                        localStorage.removeItem(Constant.SUB_FACILITY)
                        window.location.reload();
                    }
                })
            }
        })


        api.create().getProfile().then(response => {
            // console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setNama(response.data.data.fullname)
                    setRole(response.data.data.role)
                    localStorage.setItem(Constant.CURRENT_COUNTER, response.data.data.facility_counter_id === null ? "CURRENT_COUNTER" : response.data.data.facility_counter_id)
                    localStorage.setItem(Constant.SUB_FACILITY, response.data.data.sub_facility_id === null ? "SUB_FACILITY" : response.data.data.sub_facility_id)
                    localStorage.setItem(Constant.USER_ID, response.data.data.id)
                    // getWebSocketNotif(response.data.data.id)
                }
            }
        })
    }

    const handleStopFacility = () => {
        let payload = {
            "facility_id": detailNotif.facility_id,
            "sub_facility_id": detailNotif.sub_facility_id,
            "facility_counter_id": detailNotif.facility_counter_id,
            "sub_facility_queue_id": detailNotif.sub_facility_queue_id,
            "new_notes": newNotes,
            "refferal_code": referral,
            "status": "DONE"
        }
        api.create().updateListPemanggilanSubFacilityCounter(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setNewNotes("")
                    setReferral("")
                    setVisibleStopFacility(false)
                    getNotification()
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                }
            }
        })
    }

    const handleStartFacility = () => {
        let payload = {
            "facility_id": detailNotif.facility_id,
            "sub_facility_id": detailNotif.sub_facility_id,
            "facility_counter_id": detailNotif.facility_counter_id,
            "sub_facility_queue_id": detailNotif.sub_facility_queue_id,
            "new_notes": newNotes,
            "refferal_code": referral,
            "status": "START"
        }
        api.create().updateListPemanggilanSubFacilityCounter(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setNewNotes("")
                    setReferral("")
                    setVisibleStopFacility(false)
                    getNotification()
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                }
            }
        })
    }

    const handleSkipFacility = () => {
        let payload = {
            "facility_id": detailNotif.facility_id,
            "sub_facility_id": detailNotif.sub_facility_id,
            "facility_counter_id": detailNotif.facility_counter_id,
            "sub_facility_queue_id": detailNotif.sub_facility_queue_id,
            "new_notes": newNotes,
            "refferal_code": referral,
            "status": "SKIP"
        }
        api.create().updateListPemanggilanSubFacilityCounter(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setNewNotes("")
                    setReferral("")
                    setVisibleStopFacility(false)
                    getNotification()
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                }
            }
        })
    }

    const handleHoldDoctor = () => {
        let payload = {
            "doctor_schedule_id": selectNotification !== null ? selectNotification.doctor_schedule_id : detailNotif.doctor_schedule_id,
            "doctor_schedule_detail_id": selectNotification !== null ? selectNotification.doctor_schedule_detail_id : detailNotif.doctor_schedule_detail_id,
            "new_notes": newNotes,
            "status": "HOLD"
        }
        api.create().updateListAntrian(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setOpenAlert(true)
                    setMessageAlert(response.data.message)
                    setStatusAlert("success")
                    setSelectNotification(null)
                    getNotification()
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                }
            }
        })
    }

    const handleStartDoctor = () => {
        let payload = {
            "doctor_schedule_id": selectNotification !== null ? selectNotification.doctor_schedule_id : detailNotif.doctor_schedule_id,
            "doctor_schedule_detail_id": selectNotification !== null ? selectNotification.doctor_schedule_detail_id : detailNotif.doctor_schedule_detail_id,
            "new_notes": newNotes,
            "status": "START"
        }
        api.create().updateListAntrian(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setOpenAlert(true)
                    setMessageAlert(response.data.message)
                    setStatusAlert("success")
                    setSelectNotification(null)
                    getNotification()
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                }
            }
        })
    }

    const handleSkipDoctor = () => {
        let payload = {
            "doctor_schedule_id": selectNotification !== null ? selectNotification.doctor_schedule_id : detailNotif.doctor_schedule_id,
            "doctor_schedule_detail_id": selectNotification !== null ? selectNotification.doctor_schedule_detail_id : detailNotif.doctor_schedule_detail_id,
            "status": "SKIP"
        }
        api.create().updateListAntrian(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setOpenAlert(true)
                    setMessageAlert(response.data.message)
                    setStatusAlert("success")
                    setSelectNotification(null)
                    getNotification()
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                }
            }
        })
    }

    const handleStopDoctor = () => {
        let payload = {
            "doctor_schedule_id": selectNotification !== null ? selectNotification.doctor_schedule_id : detailNotif.doctor_schedule_id,
            "doctor_schedule_detail_id": selectNotification !== null ? selectNotification.doctor_schedule_detail_id : detailNotif.doctor_schedule_detail_id,
            "new_notes": newNotes,
            "status": "DONE"
        }
        api.create().updateListAntrian(payload).then(response => {
            if (response.data) {
                if (response.data.status === true) {
                    setOpenAlert(true)
                    setMessageAlert(response.data.message)
                    setStatusAlert("success")
                    setNewNotes("")
                    setSelectNotification(null)
                    setVisibleStopDoctor(false)
                    getNotification()
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.data)
                        setStatusAlert("warning")
                    }
                }
            }
        })
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleLink = () => {
        history.push({
            pathname: detailNotif.facility_id === 13 ? '/registrasi/pemanggilan-all-registrasi' : '/registrasi-umum/pemanggilan-registrasi',
            name: 'Pemanggilan Fasilitas',
            search: '',  // query string
            state: {  // location state
                id: detailNotif.facility_id,
                nama: detailNotif.facility_name,
                dataNotif: detailNotif
            },
        })
    }

    function handleCollapse(item) {
        setOpen(true);
        let arr = data.array
        let index = arr.findIndex((val) => val.label === item.label)
        arr[index].collapse = !arr[index].collapse
        setData({ ...data, data: arr })
    }

    const selectSub = (e) => {
        // console.log(e);
        setDataReservasi([])
        setOpen(true)
        setMenuid(e.id)
        setSelectSub(e.label)
        setSelectSubPath(e.path)
        setSelectedIndex("")
        setSelectedPath("")
    }

    const selectIndex = (e) => {
        // console.log(e);
        setDataReservasi([])
        setMenuid(e.id)
        setSelectSub("")
        setSelectSubPath("")
        setSelectedIndex(e.label)
        setSelectedPath(e.path)
        // alert(e)
        // if (open === false) {
        // setOpen(true)
        // }
    }

    // console.log(location);

    return (
        <div className={classes.root}>
            {/* <CssBaseline /> */}
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                })}
            >
                {/* <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        className={clsx(classes.menuButton, {
                            [classes.hide]: open,
                        })}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap>
                        Mini variant drawer
          </Typography>
                </Toolbar> */}
            </AppBar>
            <Drawer
                variant="permanent"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}
            >
                <div className={classes.toolbar} style={{ border: 0, paddingTop: 10 }}>
                    <div style={{ width: '100%' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ display: 'flex' }}>
                                <img src={localStorage.getItem(Constant.LOGO_RS)} style={{ height: 30, width: 26, marginLeft: !open ? 5 : 20 }} />
                                {open ? <Typography style={{ marginLeft: 10, color: 'white', fontWeight: 'bold', alignSelf: 'center' }}>{localStorage.getItem(Constant.NAMA_RS)}</Typography> : null}
                            </div>
                            {open && (
                                <div className='icon-drawer-left' style={{ alignSelf: 'center' }}>
                                    <IconButton
                                        color="inherit"
                                        aria-label="open drawer"
                                        onClick={!open ? handleDrawerOpen : handleDrawerClose}
                                        edge="start"
                                        style={{ outline: 'none', padding: 0 }}
                                    >
                                        <MenuIcon style={{ color: 'white' }} />
                                    </IconButton>
                                </div>
                            )}
                        </div>
                        <div style={{ borderBottom: 1, borderBottomColor: 'lightgray', borderBottomStyle: 'solid', marginTop: 10 }} />

                    </div>
                    {/* <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    </IconButton> */}
                </div>
                {/* <Divider /> */}
                <List>
                    {data.array && data.array.map((item, index) => (
                        <div style={{ marginTop: index === 0 ? null : 5 }} >
                            {item.subItem.length > 0 ?
                                <a data-tip={item.label} data-for={item.label}>
                                    <div style={{ justifyContent: 'space-between', flexDirection: 'row', display: 'flex', paddingLeft: open ? 20 : 0, paddingRight: open ? 10 : 5, cursor: 'pointer' }} onClick={() => { handleCollapse(item) }}>
                                        <ListItem key={item.label}>
                                            <ListItemIcon style={{ minWidth: open ? 40 : 56 }}>
                                                <div style={{ backgroundColor: !open ? pathname === item.path ? "white" : "transparent" : 'transparent', padding: 5, borderRadius: 10 }}>
                                                    <img
                                                        src={
                                                            item.img === "dashboard" ? dashboard :
                                                                item.img === "masterdata" ? masterData :
                                                                    item.img === "registrasi" ? registration :
                                                                        item.img === "regisgeneral" ? regisgeneral :
                                                                            item.img === "regisasuransi" ? regisasuransi :
                                                                                item.img === "regisbpjs" ? regisbpjs :
                                                                                    item.img === "nursestation" ? nurseStation :
                                                                                        item.img === "screening" ? screening :
                                                                                            item.img === "lab" ? lab :
                                                                                                item.img === "radiologi" ? radiologi :
                                                                                                    item.img === "dokter" ? dokter :
                                                                                                        item.img === "farmasi" ? farmasi :
                                                                                                            item.img === "telemedicine" ? telemedicine :
                                                                                                                item.img === "transaksi" || item.img === "kasir" ? transaksi :
                                                                                                                    item.img === "schedule" ? schedule :
                                                                                                                        item.img === "report" ? report :
                                                                                                                            item.img === "berkasbpjs" ? berkasbpjs :
                                                                                                                                item.img === "emergency" ? emergency :
                                                                                                                                    item.img === "upload" ? icUpload :
                                                                                                                                        item.img === "lain-lain" ? icOtherMenu :
                                                                                                                                            setting
                                                        }
                                                        style={{ width: 20, height: 20 }} />
                                                </div>
                                            </ListItemIcon>
                                            <Typography style={{ fontFamily: 'Poppins', color: '#d5e0dc', fontSize: 14 }}>{item.label}</Typography>
                                        </ListItem>
                                        {item.subItem.length > 0 ? (item.collapse ? <ExpandLess style={{ color: "#d5e0dc", alignSelf: 'center' }} /> : <ExpandMore style={{ color: "#d5e0dc", alignSelf: 'center' }} />) : null}
                                        {!open && (<ReactTooltip border={true} id={item.label} place="bottom" type="light" effect="solid" />)}
                                    </div>
                                </a>
                                :
                                <Link to={`${url}${item.path}`}>
                                    <div style={{ paddingLeft: open ? 20 : 0 }} className={pathname === item.path ? "active" : ""}>
                                        <a data-tip={item.label} data-for={item.label}>
                                            <ListItem button key={item.label}
                                                onClick={() => selectIndex(item)}
                                                style={{ backgroundColor: open ? pathname === item.path ? "white" : "transparent" : 'transparent', borderTopLeftRadius: 20, borderBottomLeftRadius: 20 }}>
                                                <ListItemIcon style={{ minWidth: open ? 40 : 56 }}>
                                                    <div style={{ backgroundColor: !open ? pathname === item.path ? "#white" : "transparent" : 'transparent', padding: 5, borderRadius: 10 }}>
                                                        <img
                                                            src={
                                                                item.img === "dashboard" ? dashboard :
                                                                    item.img === "masterdata" ? masterData :
                                                                        item.img === "regisgeneral" ? regisgeneral :
                                                                            item.img === "regisasuransi" ? regisasuransi :
                                                                                item.img === "registrasi" ? registration :
                                                                                    item.img === "regisbpjs" ? regisbpjs :
                                                                                        item.img === "nursestation" ? nurseStation :
                                                                                            item.img === "screening" ? screening :
                                                                                                item.img === "lab" ? lab :
                                                                                                    item.img === "radiologi" ? radiologi :
                                                                                                        item.img === "dokter" ? dokter :
                                                                                                            item.img === "farmasi" ? farmasi :
                                                                                                                item.img === "telemedicine" ? telemedicine :
                                                                                                                    item.img === "transaksi" || item.img === "kasir" ? transaksi :
                                                                                                                        item.img === "schedule" ? schedule :
                                                                                                                            item.img === "report" ? report :
                                                                                                                                item.img === "berkasbpjs" ? berkasbpjs :
                                                                                                                                    item.img === "emergency" ? emergency :
                                                                                                                                        item.img === "upload" ? icUpload :
                                                                                                                                            item.img === "lain-lain" ? icOtherMenu :
                                                                                                                                                setting
                                                            }
                                                            style={{ width: 20, height: 20 }} />
                                                    </div>
                                                </ListItemIcon>
                                                <Typography style={{ fontFamily: 'Poppins', color: pathname === item.path ? '#2a9c6c' : '#d5e0dc', fontSize: 14 }}>{item.label}</Typography>
                                            </ListItem>
                                        </a>
                                        {!open && (<ReactTooltip border={true} id={item.label} place="bottom" type="light" effect="solid" />)}
                                    </div>
                                </Link>
                            }
                            {item.subItem.length > 0 &&
                                <div>
                                    <Collapse in={item.collapse} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            {item.subItem.map((sub, indexs) => {
                                                return (
                                                    <Link to={sub.label === "Logout" ? `/` : `${url}${sub.path}`}>
                                                        <a data-tip={sub.label} data-for={sub.label}>
                                                            <div
                                                                style={{ paddingLeft: 60, borderTopLeftRadius: 20, borderBottomLeftRadius: 20, display: 'flex' }} className={selectedSubPath === sub.path ? "active" : ""}
                                                                onClick={() => sub.label === "Logout" ? logout() : selectSub(sub)}>
                                                                <ListItem button style={{ backgroundColor: selectedSubPath === sub.path ? "white" : "transparent", borderTopLeftRadius: 20, borderBottomLeftRadius: 20 }}>
                                                                    <Typography style={{ fontFamily: 'Poppins', color: selectedSubPath === sub.path ? '#2a9c6c' : '#d5e0dc', fontSize: 14 }}>{sub.label}</Typography>
                                                                </ListItem>
                                                            </div>
                                                        </a>
                                                        {!open && (<ReactTooltip border={true} id={sub.label} place="bottom" type="light" effect="solid" />)}
                                                    </Link>
                                                )
                                            })}
                                        </List>
                                    </Collapse>
                                </div>
                            }
                        </div>
                        // <ListItem button key={text}>
                        //     <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
                        //     <ListItemText primary={text}/>
                        // </ListItem>
                    ))}
                </List>
            </Drawer>
            <main style={{ flexGrow: 1, padding: 10, backgroundColor: '#2a9c6c', paddingLeft: 0, overflow: 'scroll' }}>
                <Snackbar open={openAlert} autoHideDuration={2000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity={statusAlert}>
                        {messageAlert}
                    </Alert>
                </Snackbar>
                <div style={{ borderRadius: 20, backgroundColor: 'white', height: height - 20, padding: '0px 20px 20px 20px', width: width < 800 ? 800 : open ? width - 320 : width - 80, maxWidth: width < 800 ? 800 : width }}>
                    <div style={{ borderBottom: 1, borderBottomColor: 'black', borderBottomStyle: 'solid', display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex' }}>
                            {location.pathname === "/dokter/detail-pemanggilan" || location.pathname === '/masterdata/tambah-skrining' || location.pathname === '/dokter/daftar-reservasi'
                                || location.pathname === "/masterdata/detail-skrining" || location.pathname === "/skrining/create-skrining-pasien" || location.pathname === "/transaksi/pemanggilan-transaksi"
                                || location.pathname === "/masterdata/edit-jadwal" || location.pathname === "/farmasi/pemanggilan" || location.pathname === "/lab/pemanggilan-verifikasi" || location.pathname === "/pembayaran/detail-monitoring"
                                || location.pathname === "/registrasi-umum/pemanggilan-registrasi" || location.pathname === "/radiologi/pemanggilan-radiologi" || location.pathname === "/registrasi-asuransi/pemanggilan-registrasi" || location.pathname === "/registrasi-bpjs/pemanggilan-registrasi"
                                || location.pathname === "/masterdata/detail-akun" || location.pathname === "/schedule/tambah-jadwal-poliklinik" || location.pathname === "/setting/tambah-faq" || location.pathname === "/setting/edit-faq" || location.pathname === "/setting/tambah-tnc" || location.pathname === "/setting/edit-tnc"
                                || location.pathname === "/setting/tambah-pp" || location.pathname === "/setting/edit-pp" || location.pathname === "/transaksi/detail-riwayat" || location.pathname === "/farmasi/farmasi-dalam-list" || location.pathname === "/transaksi/detail-riwayat-skrining-pasien"
                                || location.pathname === "/setting/tambah-promosi" || location.pathname === "/setting/edit-promosi" || location.pathname === "/setting/tambah-media" || location.pathname === "/setting/edit-media" || location.pathname === "/farmasi/detail-resep"
                                || location.pathname === "/emergency/detail-emergency" || location.pathname === "/emergency/add-emergency" || location.pathname === "/emergency/detail-history-emergency" || location.pathname === "/pembayaran/detail-tagihan" || location.pathname === "/kasir/pemanggilan-verifikasi"
                                || location.pathname === "/lab/hasil-lab" || location.pathname === "/radiologi/hasil-radiologi" || location.pathname === "/registrasi/pemanggilan-all-registrasi" || location.pathname === "/pembayaran/detail-tagihan-non-reservasi-farmasi" || location.pathname === "/schedule/edit-jadwal-dokter" 
                                || location.pathname === "/pembayaran/detail-tagihan-non-reservasi-lab" || location.pathname === "/pembayaran/detail-tagihan-non-reservasi-radiologi" ?
                                <div style={{ display: 'flex', textAlign: 'center' }}>
                                    <div className={open ? 'icon-drawer-right' : ''}>
                                        <IconButton
                                            color="inherit"
                                            aria-label="open drawer"
                                            onClick={() => history.goBack()}
                                            edge="start"
                                            style={{ outline: 'none' }}
                                        >
                                            <img src={back} style={{ cursor: 'pointer', width: 20, height: 20 }} />
                                        </IconButton>
                                    </div>
                                    <Typography style={{ fontSize: 20, color: '#278863', fontFamily: 'Poppins', fontWeight: 500, textAlign: 'center', alignSelf: 'center' }}>{location.name === undefined ? title : location.name}</Typography>
                                </div>
                                :
                                location.pathname === '/schedule/tambah-jadwal-dokter' ?
                                    <div style={{ display: 'flex', textAlign: 'center' }}>
                                        <div className={open ? 'icon-drawer-right' : ''}>
                                            <IconButton
                                                color="inherit"
                                                aria-label="open drawer"
                                                onClick={() => history.push({
                                                    pathname: '/schedule/jadwal-transaksi-dokter',
                                                    state: {
                                                        data: location.state
                                                    }
                                                })}
                                                edge="start"
                                                style={{ outline: 'none' }}
                                            >
                                                <img src={back} style={{ cursor: 'pointer', width: 20, height: 20 }} />
                                            </IconButton>
                                        </div>
                                        <Typography style={{ fontSize: 20, color: '#278863', fontFamily: 'Poppins', fontWeight: 500, textAlign: 'center', alignSelf: 'center' }}>{location.name === undefined ? title : location.name}</Typography>
                                    </div>
                                    :
                                    location.pathname === '/masterdata/tambah-jadwal' ?
                                        <div style={{ display: 'flex', textAlign: 'center' }}>
                                            <div className={open ? 'icon-drawer-right' : ''}>
                                                <IconButton
                                                    color="inherit"
                                                    aria-label="open drawer"
                                                    onClick={() => history.push({
                                                        pathname: '/schedule/jadwal-dokter',
                                                        state: {
                                                            data: location.state
                                                        }
                                                    })}
                                                    edge="start"
                                                    style={{ outline: 'none' }}
                                                >
                                                    <img src={back} style={{ cursor: 'pointer', width: 20, height: 20 }} />
                                                </IconButton>
                                            </div>
                                            <Typography style={{ fontSize: 20, color: '#278863', fontFamily: 'Poppins', fontWeight: 500, textAlign: 'center', alignSelf: 'center' }}>{location.name === undefined ? title : location.name}</Typography>
                                        </div>
                                        :
                                        location.pathname === '/dokter/detail-reservasi-dokter' ?
                                            <div style={{ display: 'flex', textAlign: 'center' }}>
                                                <div className={open ? 'icon-drawer-right' : ''}>
                                                    <IconButton
                                                        color="inherit"
                                                        aria-label="open drawer"
                                                        onClick={() => history.replace({
                                                            pathname: '/dokter/reservasi-dokter',
                                                            state: {
                                                                data: location.state
                                                            }
                                                        })}
                                                        edge="start"
                                                        style={{ outline: 'none' }}
                                                    >
                                                        <img src={back} style={{ cursor: 'pointer', width: 20, height: 20 }} />
                                                    </IconButton>
                                                </div>
                                                <Typography style={{ fontSize: 20, color: '#278863', fontFamily: 'Poppins', fontWeight: 500, textAlign: 'center', alignSelf: 'center' }}>{location.name === undefined ? title : location.name}</Typography>
                                            </div> :
                                            location.pathname === '/dokter/detail-histori-reservasi' ?
                                                <div style={{ display: 'flex', textAlign: 'center' }}>
                                                    <div className={open ? 'icon-drawer-right' : ''}>
                                                        <IconButton
                                                            color="inherit"
                                                            aria-label="open drawer"
                                                            onClick={() => history.replace({
                                                                pathname: '/dokter/history-reservasi',
                                                                state: {
                                                                    data: location.state
                                                                }
                                                            })}
                                                            edge="start"
                                                            style={{ outline: 'none' }}
                                                        >
                                                            <img src={back} style={{ cursor: 'pointer', width: 20, height: 20 }} />
                                                        </IconButton>
                                                    </div>
                                                    <Typography style={{ fontSize: 20, color: '#278863', fontFamily: 'Poppins', fontWeight: 500, textAlign: 'center', alignSelf: 'center' }}>{location.name === undefined ? title : location.name}</Typography>
                                                </div> :
                                                location.pathname === '/transaksi/detail-skrining-pasien' ?
                                                    <div style={{ display: 'flex', textAlign: 'center' }}>
                                                        <div className={open ? 'icon-drawer-right' : ''}>
                                                            <IconButton
                                                                color="inherit"
                                                                aria-label="open drawer"
                                                                onClick={() => history.goBack()}
                                                                edge="start"
                                                                style={{ outline: 'none' }}
                                                            >
                                                                <img src={back} style={{ cursor: 'pointer', width: 20, height: 20 }} />
                                                            </IconButton>
                                                        </div>
                                                        <Typography style={{ marginTop: 11, fontWeight: 500 }}>Detail Skrining</Typography>
                                                    </div>
                                                    : location.pathname === "/masterdata/detail-Jadwal-dokter" ?
                                                        <div style={{ display: 'flex', textAlign: 'center' }}>
                                                            <div className={open ? 'icon-drawer-right' : ''}>
                                                                <IconButton
                                                                    color="inherit"
                                                                    aria-label="open drawer"
                                                                    onClick={() => history.push({
                                                                        pathname: '/schedule/jadwal-dokter',
                                                                        state: {
                                                                            data: location.state
                                                                        }
                                                                    })}
                                                                    edge="start"
                                                                    style={{ outline: 'none' }}
                                                                >
                                                                    <img src={back} style={{ cursor: 'pointer', width: 20, height: 20 }} />
                                                                </IconButton>
                                                            </div>
                                                            <Typography style={{ fontSize: 20, color: '#278863', fontFamily: 'Poppins', fontWeight: 500, textAlign: 'center', alignSelf: 'center' }}>{location.name ? location.name : "Detail Jadwal Dokter"}</Typography>
                                                        </div>
                                                        : location.pathname === "/schedule/detail-jadwal-fasilitas" ?
                                                            <div style={{ display: 'flex', textAlign: 'center' }}>
                                                                <div className={open ? 'icon-drawer-right' : ''}>
                                                                    <IconButton
                                                                        color="inherit"
                                                                        aria-label="open drawer"
                                                                        onClick={() => history.push({
                                                                            pathname: '/schedule/jadwal-fasilitas',
                                                                            state: {
                                                                                data: location.state
                                                                            }
                                                                        })}
                                                                        edge="start"
                                                                        style={{ outline: 'none' }}
                                                                    >
                                                                        <img src={back} style={{ cursor: 'pointer', width: 20, height: 20 }} />
                                                                    </IconButton>
                                                                </div>
                                                                <Typography style={{ fontSize: 20, color: '#278863', fontFamily: 'Poppins', fontWeight: 500, textAlign: 'center', alignSelf: 'center' }}>{location.name === undefined ? title : location.name}</Typography>
                                                            </div>
                                                            : location.pathname === "/schedule/detail-jadwal-poli" ?
                                                                <div style={{ display: 'flex', textAlign: 'center' }}>
                                                                    <IconButton
                                                                        color="inherit"
                                                                        aria-label="open drawer"
                                                                        onClick={() => history.push({
                                                                            pathname: '/schedule/jadwal-poli',
                                                                            state: {
                                                                                data: location.state
                                                                            }
                                                                        })}
                                                                        edge="start"
                                                                        style={{ outline: 'none' }}
                                                                    >
                                                                        <img src={back} style={{ cursor: 'pointer', width: 20, height: 20 }} />
                                                                    </IconButton>
                                                                    <Typography style={{ fontSize: 20, color: '#278863', fontFamily: 'Poppins', fontWeight: 500, textAlign: 'center', alignSelf: 'center' }}>{location.name === undefined ? title : location.name}</Typography>
                                                                </div>
                                                                : location.pathname === "/schedule/edit-jadwal-dokter" ?
                                                                    <div style={{ display: 'flex', textAlign: 'center' }}>
                                                                        <IconButton
                                                                            color="inherit"
                                                                            aria-label="open drawer"
                                                                            onClick={() => history.push({
                                                                                pathname: '/schedule/jadwal-transaksi-dokter',
                                                                                state: {
                                                                                    data: location.state
                                                                                }
                                                                            })}
                                                                            edge="start"
                                                                            style={{ outline: 'none' }}
                                                                        >
                                                                            <img src={back} style={{ cursor: 'pointer', width: 20, height: 20 }} />
                                                                        </IconButton>
                                                                        <Typography style={{ fontSize: 20, color: '#278863', fontFamily: 'Poppins', fontWeight: 500, textAlign: 'center', alignSelf: 'center' }}>{location.name === undefined ? title : location.name}</Typography>
                                                                    </div>
                                                                    : location.pathname === "/masterdata/tambah-jadwal-fasilitas" ?
                                                                        <div style={{ display: 'flex', textAlign: 'center' }}>
                                                                            <IconButton
                                                                                color="inherit"
                                                                                aria-label="open drawer"
                                                                                onClick={() => history.push({
                                                                                    pathname: '/schedule/jadwal-fasilitas',
                                                                                    state: {
                                                                                        data: location.state
                                                                                    }
                                                                                })}
                                                                                edge="start"
                                                                                style={{ outline: 'none' }}
                                                                            >
                                                                                <img src={back} style={{ cursor: 'pointer', width: 20, height: 20 }} />
                                                                            </IconButton>
                                                                            <Typography style={{ fontSize: 20, color: '#278863', fontFamily: 'Poppins', fontWeight: 500, textAlign: 'center', alignSelf: 'center' }}>{location.name === undefined ? title : location.name}</Typography>
                                                                        </div>
                                                                        : location.pathname === "/masterdata/tambah-jadwal-poliklinik" ?
                                                                            <div style={{ display: 'flex', textAlign: 'center' }}>
                                                                                <IconButton
                                                                                    color="inherit"
                                                                                    aria-label="open drawer"
                                                                                    onClick={() => history.push({
                                                                                        pathname: '/schedule/jadwal-poli',
                                                                                        state: {
                                                                                            data: location.state
                                                                                        }
                                                                                    })}
                                                                                    edge="start"
                                                                                    style={{ outline: 'none' }}
                                                                                >
                                                                                    <img src={back} style={{ cursor: 'pointer', width: 20, height: 20 }} />
                                                                                </IconButton>
                                                                                <Typography style={{ fontSize: 20, color: '#278863', fontFamily: 'Poppins', fontWeight: 500, textAlign: 'center', alignSelf: 'center' }}>{location.name === undefined ? title : location.name}</Typography>
                                                                            </div>
                                                                            : location.pathname === "/schedule/draft-master-jadwal" ?
                                                                                <div style={{ display: 'flex', textAlign: 'center' }}>
                                                                                    <IconButton
                                                                                        color="inherit"
                                                                                        aria-label="open drawer"
                                                                                        onClick={() => history.push({
                                                                                            pathname: '/schedule/draft-master-jadwal-dokter',
                                                                                            state: {
                                                                                                data: location.state
                                                                                            }
                                                                                        })}
                                                                                        edge="start"
                                                                                        style={{ outline: 'none' }}
                                                                                    >
                                                                                        <img src={back} style={{ cursor: 'pointer', width: 20, height: 20 }} />
                                                                                    </IconButton>
                                                                                    <Typography style={{ fontSize: 20, color: '#278863', fontFamily: 'Poppins', fontWeight: 500, textAlign: 'center', alignSelf: 'center' }}>{location.name === undefined ? title : location.name}</Typography>
                                                                                </div>
                                                                                :
                                                                                <div style={{ display: 'flex', textAlign: 'center' }}>
                                                                                    <div className={open ? 'icon-drawer-right' : ''}>
                                                                                        <IconButton
                                                                                            color="inherit"
                                                                                            aria-label="open drawer"
                                                                                            onClick={!open ? handleDrawerOpen : handleDrawerClose}
                                                                                            edge="start"
                                                                                            style={{ outline: 'none' }}
                                                                                        >
                                                                                            <MenuIcon />
                                                                                        </IconButton>
                                                                                    </div>
                                                                                    <Typography style={{ fontSiza: 24, color: '#278863', fontFamily: 'Poppins', fontWeight: 500, textAlign: 'center', alignSelf: 'center' }}>{selectedIndex === "" ? selectedSubIndex === "" ? 'test' : selectedSubIndex : title}</Typography>
                                                                                </div>
                            }
                        </div>
                        <div style={{ display: 'flex' }}>
                            <Avatar alt="Cindy Baker" style={{ marginRight: 20, alignSelf: 'center' }} />
                            <Typography style={{ alignSelf: 'center' }}>{nama}</Typography>
                            <IconButton
                                style={{ outline: 'none' }}
                                aria-label="more"
                                aria-controls="long-menu"
                                aria-haspopup="true"
                                onClick={handleClickMenu}
                            >
                                <ExpandMore />
                            </IconButton>
                            <Menu
                                id="long-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={openMenu}
                                onClose={handleCloseMenu}
                                PaperProps={{
                                    style: {
                                        maxHeight: ITEM_HEIGHT * 4.5,
                                        width: '20ch',
                                    },
                                }}
                            >
                                {options.map((option) => (
                                    <MenuItem key={option} selected={option === 'Pyxis'}>
                                        <div onClick={() => handleOption(option)} style={{ width: '100%' }}>
                                            {option}
                                        </div>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </div>
                    </div>
                    {menuid !== "" && (
                        <div>
                            <Switch>
                                {HomeRoutes.map((route, index) => (
                                    // You can render a <Route> in as many places
                                    // as you want in your app. It will render along
                                    // with any other <Route>s that also match the URL.
                                    // So, a sidebar or breadcrumbs or anything else
                                    // that requires you to render multiple things
                                    // in multiple places at the same URL is nothing
                                    // more than multiple <Route>s.
                                    <Route
                                        key={index}
                                        path={route.path}
                                        // exact={route.exact}
                                        location={location}
                                        children={<route.main height={height} open={open} width={width} menuid={menuid} setDataReservasi={(val) => dataReservasi(val)} reservasi={reservasi} location={location} setShowNotif={(val) => setShowNotif(val)} setSelectNotification={(val) => setSelectNotification(val)} nama={nama} />}
                                    />
                                ))}
                            </Switch>
                        </div>
                    )}
                    {showNotif && visibleNotif && detailNotif && (
                        <div>
                            <div style={{ position: 'absolute', bottom: 50, height: 75, borderRadius: 50 }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ cursor: 'pointer' }} onClick={() => setVisibleFloat(!visibleFloat)}>
                                        <img src={circle} style={{ width: 64, height: 64 }} />
                                        <img src={visibleFloat ? icClose : icProses} style={{ width: 22, height: 22, marginLeft: -43, marginTop: -10 }} />
                                    </div>
                                    <div onClick={() => detailNotif.queue_type === "doctor" ?
                                        history.push({
                                            pathname: '/dokter/detail-pemanggilan',
                                            name: 'Detail Pemanggilan',
                                            search: '',  // query string
                                            state: {  // location state
                                                doctorID: selectNotification !== null ? selectNotification.doctor_id : detailNotif.doctor_id,
                                                scheduleID: selectNotification !== null ? selectNotification.doctor_schedule_id : detailNotif.doctor_schedule_id
                                            },
                                        })
                                        : handleLink()} className={visibleFloat ? "basket hide" : "basket"} style={{ backgroundColor: '#278863', width: 230, marginLeft: 25, marginTop: -7, borderRadius: '15px 15px 15px 0px', padding: '8px 13px', cursor: 'pointer' }}>
                                        <Typography style={{ color: 'white', fontSize: 18 }}>{detailNotif.is_called === 1 && detailNotif.queue_status !== 2 ? 'Antrian Dipanggil' : 'Antrian Dilayani'}</Typography>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography style={{ color: 'white', fontSize: 16, fontWeight: '500' }}>{selectNotification !== null ? selectNotification.queue_number : detailNotif.queue_number ? detailNotif.queue_number : '-'}</Typography>
                                            <Typography className={visibleFloat ? "" : "blink"} style={{ color: '#ffff82', fontSize: 16, fontWeight: '500' }}>{selectNotification !== null ? selectNotification.queue_time : detailNotif.queue_time}</Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={!visibleFloat ? "basket hide" : "basket"} style={{ position: 'absolute', bottom: 135, width: 330, borderRadius: '20px 20px 20px 0', boxShadow: '0 -4px 40px 0 rgba(0, 0, 0, 0.4)', backgroundColor: 'white', opacity: visibleFloat ? 1 : 0 }}>
                                <div style={{ height: 46, width: '100%', backgroundColor: '#278863', borderTopRightRadius: 20, borderTopLeftRadius: 20, display: 'flex', alignItems: 'center', padding: '0 20px', justifyContent: 'space-between' }}>
                                    <div style={{ display: 'flex' }}>
                                        <img src={localStorage.getItem(Constant.LOGO_RS)} style={{ height: 30, width: 30 }} />
                                        <Typography style={{ marginLeft: 10, color: 'white', fontSize: 16, fontWeight: '500', alignSelf: 'center' }}>{detailNotif.is_called === 1 && detailNotif.queue_status !== 2 ? 'Antrian Dipanggil' : 'Antrian Dilayani'}</Typography>
                                    </div>
                                    {notificationType === "doctor" && (
                                        <div>
                                            <IconButton
                                                style={{ outline: 'none' }}
                                                aria-label="more"
                                                aria-controls="long-dropdown"
                                                aria-haspopup="true"
                                                onClick={() => setVisiblePopup(true)}
                                            >
                                                <ExpandMore color={"white"} style={{ color: 'white' }} />
                                            </IconButton>
                                        </div>
                                    )}
                                </div>
                                <div style={{ padding: 20 }}>
                                    <Typography style={{ color: '#000000', fontSize: 20, fontWeight: '600' }}>{selectNotification !== null ? selectNotification.queue_number : detailNotif.queue_number ? detailNotif.queue_number : '-'}</Typography>
                                    <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                                        <Typography style={{ color: '#000000', fontSize: 16, }}>{detailNotif.queue_type === "doctor" ? selectNotification !== null ? selectNotification.location : detailNotif.location : detailNotif.facility_name ? detailNotif.facility_name : '-'}</Typography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Typography style={{ color: '#000000', fontSize: 13, }}>{selectNotification !== null ? selectNotification.payment_option_name : detailNotif.payment_option_name ? detailNotif.payment_option_name : '-'}</Typography>
                                        <Typography style={{ color: '#000000', fontSize: 13, }}>{selectNotification !== null ? selectNotification.queue_time : detailNotif.queue_time ? detailNotif.queue_time : '-'}</Typography>
                                    </div>
                                    <div style={{ borderTop: 1, borderTopColor: '#bdc3c7', borderTopStyle: 'solid', marginTop: 10 }} />
                                    {notificationType === "doctor" ?
                                        detailNotif.is_called === 1 && detailNotif.queue_status !== 2 ?
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                                                <div
                                                    onClick={() => handleStartDoctor()}
                                                    style={{ width: '40%', border: 'solid 2px #FFA654', borderRadius: 30, boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)', cursor: 'pointer' }}>
                                                    <Typography style={{ color: '#FFA654', fontSize: 14, textAlign: 'center' }}>Start</Typography>
                                                </div>
                                                <div
                                                    onClick={() => handleSkipDoctor()}
                                                    style={{ width: '40%', border: 'solid 2px #ff5b5b', borderRadius: 30, boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)', cursor: 'pointer' }}>
                                                    <Typography style={{ color: '#ff5b5b', fontSize: 14, textAlign: 'center' }}>Lewati</Typography>
                                                </div>
                                            </div>
                                            :
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                                                <div
                                                    onClick={() => handleHoldDoctor()}
                                                    style={{ width: '40%', border: 'solid 2px #FFA654', borderRadius: 30, boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)', cursor: 'pointer' }}>
                                                    <Typography style={{ color: '#FFA654', fontSize: 14, textAlign: 'center' }}>Hold</Typography>
                                                </div>
                                                <div
                                                    onClick={() => setVisibleStopDoctor(true)}
                                                    style={{ width: '40%', border: 'solid 2px #ff5b5b', borderRadius: 30, boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)', cursor: 'pointer' }}>
                                                    <Typography style={{ color: '#ff5b5b', fontSize: 14, textAlign: 'center' }}>Stop</Typography>
                                                </div>
                                            </div> :
                                        detailNotif.is_called === 1 && detailNotif.queue_status !== 2 ?
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                                                <div
                                                    onClick={() => handleStartFacility()}
                                                    style={{ width: '40%', border: 'solid 2px #FFA654', borderRadius: 30, boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)', cursor: 'pointer' }}>
                                                    <Typography style={{ color: '#FFA654', fontSize: 14, textAlign: 'center' }}>Start</Typography>
                                                </div>
                                                <div
                                                    onClick={() => handleSkipFacility()}
                                                    style={{ width: '40%', border: 'solid 2px #ff5b5b', borderRadius: 30, boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)', cursor: 'pointer' }}>
                                                    <Typography style={{ color: '#ff5b5b', fontSize: 14, textAlign: 'center' }}>Lewati</Typography>
                                                </div>
                                            </div>
                                            :
                                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
                                                <div
                                                    onClick={() => {
                                                        setVisibleStopFacility(true)
                                                    }}
                                                    style={{ width: '40%', border: 'solid 2px #ff5b5b', borderRadius: 30, boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)', cursor: 'pointer' }}>
                                                    <Typography style={{ color: '#ff5b5b', fontSize: 14, textAlign: 'center' }}>Stop</Typography>
                                                </div>
                                            </div>

                                    }
                                </div>
                            </div>
                        </div>
                    )}
                    {/* <div className={classes.toolbar} /> */}
                </div>
                {visibleStopFacility && (
                    <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                        <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                            <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                    <div className="popup-title">
                                        <span style={{ color: 'black', fontSize: 18 }}>Tambah Catatan</span>
                                    </div>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => {
                                            setVisibleStopFacility(false)
                                        }}
                                    >
                                        <img src={CloseImage} />
                                    </button>
                                </div>
                            </div>
                            <Typography style={{ textAlign: 'start', width: '70%', margin: 'auto', paddingTop: 30 }}>No. Referensi</Typography>
                            <textarea
                                value={referral}
                                onChange={(e) => {
                                    setReferral(e.target.value)
                                }}
                                style={{ width: '70%', marginTop: 10 }}
                                placeholder={"input no. referensi"}
                            />
                            <div style={{ height: '30vh' }}>
                                <Typography style={{ textAlign: 'start', width: '70%', margin: 'auto', paddingTop: 10 }}>Catatan Baru</Typography>
                                <textarea
                                    label="Catatan Petugas"
                                    value={newNotes}
                                    onChange={(e) => {
                                        setNewNotes(e.target.value)
                                    }}
                                    style={{ width: '70%', marginTop: 10, height: '15vh' }}
                                    placeholder={"input catatan baru"}
                                />
                                <Typography style={{ fontSize: 12, color: 'rgb(255, 91, 91)' }}>Note: catatan yang sudah ditambahkan tidak bisa diubah</Typography>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
                                <div style={{ display: 'flex', justifyContent: 'flex-start', width: '25%' }}>
                                    <div
                                        onClick={() => handleStopFacility()}
                                        style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {visibleStopDoctor && (
                    <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                        <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                            <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                    <div className="popup-title">
                                        <span style={{ color: 'black', fontSize: 18 }}>Tambah Catatan</span>
                                    </div>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => {
                                            setVisibleStopDoctor(false)
                                        }}
                                    >
                                        <img src={CloseImage} />
                                    </button>
                                </div>
                            </div>
                            <div style={{ height: '30vh' }}>
                                <Typography style={{ textAlign: 'start', width: '70%', margin: 'auto', paddingTop: 30 }}>Catatan Baru</Typography>
                                <textarea
                                    label="Catatan Petugas"
                                    value={newNotes}
                                    onChange={(e) => {
                                        setNewNotes(e.target.value)
                                    }}
                                    style={{ width: '70%', marginTop: 10, height: '15vh' }}
                                    placeholder={"input catatan baru"}
                                />
                                <Typography style={{ fontSize: 12, color: 'rgb(255, 91, 91)' }}>Note: catatan yang sudah ditambahkan tidak bisa diubah</Typography>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
                                <div style={{ display: 'flex', justifyContent: 'flex-start', width: '25%' }}>
                                    <div
                                        onClick={() => handleStopDoctor()}
                                        style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {visiblePopup && (
                    <div className="App app-popup-show">
                        <div className="popup-content-low background-white" style={{ borderRadius: 20, margin: 'auto', overflow: 'auto' }}>
                            <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 20, borderTopLeftRadius: 20, backgroundColor: '#f5f5f5' }}>
                                <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                    <div className="popup-title">
                                        <span style={{ color: 'black', fontSize: 18, }}>Pilih Antrian</span>
                                    </div>
                                </div>
                                <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                    <button
                                        type="button"
                                        className="btn btn-circle btn-white"
                                        onClick={() => setVisiblePopup(false)}
                                    >
                                        <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                    </button>
                                </div>
                            </div>
                            <div style={{ padding: '20px 20px 40px' }}>
                                {/* <Typography style={{ fontWeight: 'bold' }}>PILIH ASURANSI</Typography> */}
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div style={{ width: '10%' }} />
                                    <div style={{ width: '70%' }}>
                                        <Typography style={{ textAlign: 'left', fontWeight: '500', color: '#2a9c6c' }}>Nama Dokter</Typography>
                                    </div>
                                    <div style={{ width: '20%' }}>
                                        <Typography style={{ textAlign: 'left', fontWeight: '500', color: '#2a9c6c' }}>Ruang</Typography>
                                    </div>
                                </div>
                                {dataNotication.length > 0 && dataNotication.map((item, index) => {
                                    return (
                                        <div
                                            onClick={() => {
                                                setSelectNotification(item)
                                                setVisiblePopup(false)
                                                setPickDataNotification(item)
                                                setDetailNotif(item)
                                            }}
                                            style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 10, borderBottomColor: 'grey', borderBottomWidth: 1.2, borderBottomStyle: 'solid', padding: '5px 0px' }}>
                                            <GreenRadio
                                                checked={pickDataNotification && pickDataNotification.booking_id === item.booking_id ? true : false}
                                                // value="c"
                                                name="radio"
                                                style={{ padding: 0, width: '10%' }}
                                                inputProps={{ 'aria-label': 'C' }}
                                            />
                                            <div style={{ width: '70%', }}>
                                                <Typography style={{ textAlign: 'left' }} >{item.doctor_name}</Typography>
                                            </div>
                                            <div style={{ width: '20%', }}>
                                                <Typography style={{ textAlign: 'left' }}>{item.room_name}</Typography>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                )}
            </main>
        </div>
    )
}